

/**
 * Таймаут на ожидание ответа при отправке команды на прибор
 */
export const REPLY_TIMEOUT = 6000;

/**
 * Таймаут на ожидание ответа от прибора
 */
export const DEVICE_TIMEOUT = 30000;